
export interface IOrderLineTotals {
  priceNettTotal?: number,
  costTotal?: number,
  discountTotalRatio?: number,
  discountTotalPct?: number,
  discountTotal?: number,
  marginTotal?: number,
  marginTotalRatio?: number,
  marginTotalPct?: number,
  vatEstTotal?: number
}
